import React from 'react'
import { GatsbyImage } from "gatsby-plugin-image";
import Link from '../Link'

import {
  contactFollowContainer,
  dark,
  contactFollowWrapper,
  contactFollowBlock,
  contactFollowCTA,
  followCTAs,
  followCTA,
  followImage,
  contactGridOne,
  contactGridTwo,
  contactGridThree,
} from './index.module.css'

const ContactFollowSection = ({ components, isDarkTheme, backgroundColor }) => {
  components = components ? components : []

  let gridClass = contactGridOne

  if (components.length === 2) {
    gridClass = contactGridTwo
  }

  if (components.length >= 3) {
    gridClass = contactGridThree
  }

  return (
    <div
      className={`${contactFollowContainer}${isDarkTheme ? ` ${dark}` : ''}`}
      style={{ backgroundColor }}
    >
      <div className={`${contactFollowWrapper} ${gridClass}`}>
        {components?.map((component) => (
          <div key={component?.id} className={contactFollowBlock}>
            <h2>{component?.title}</h2>
            {component.ctaText && component.ctaUrl ? (
              <Link className={contactFollowCTA} to={component.ctaUrl}>
                {component.ctaText}
              </Link>
            ) : (
              <div className={followCTAs}>
                {component?.multiCtatext &&
                  component?.multiCtatext.map((cta, index) => (
                    <Link className={followCTA} to={cta.ctaUrl} key={index}>
                      {cta?.image?.fluid ? (
                        <GatsbyImage
                          image={cta?.childImageSharp?.gatsbyImageData}
                          className={followImage}
                          imgStyle={{
                            objectFit: 'contain',
                            objectPosition: '50% 50%',
                          }}
                          alt={cta?.image?.description} />
                      ) : (
                        <img
                          className={followImage}
                          src={cta?.image?.file?.url}
                          alt={cta?.image?.description}
                        />
                      )}
                    </Link>
                  ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default ContactFollowSection
